/*
 *
 * LazyLoad Images & Videos
 * https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/
 * 
 * Usage:
 * • Consider using image macro, below (see content_alternating.twig)
 *   {{ macros.img( row.image, 'grid-2', 'alternating__image', true ) }}
 * 	
 * • If used outside of macro, `lazy-hidden` class is required, plus an additional class of choice, e.g. `js-lazy-element`
 * 
 * • Initialize from `scripts.js` => LazyLoad.init('.js-lazy-element');
 * 
 * !! Important, if you change the initialization class from the default `.js-lazy-element` you must also change it in 
 * -> /views/macros.twig 
 * -> /scss/js-components/lazy-images.scss
 * 
 */

const LazyLoad = {

	init(element) {
		let lazyImages = [].slice.call(document.querySelectorAll(element));
		let active 		 = false;

		const lazyLoad = function() {
			if (active === false) {
			active = true;
            
			setTimeout(function() {
				lazyImages.forEach(function(lazyImage) {                

					// Detect when image has entered viewport
					if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                        if (lazyImage.getElementsByTagName('img')){
                            let image = lazyImage.getElementsByTagName('img')[0];
                                image.src = image.dataset.src;
                                image.removeAttribute('data-src');
                        }  else {
                            lazyImage.src = lazyImage.dataset.src;
                            lazyImage.removeAttribute('data-src');
                        }
						
						// Flag image as loaded
						lazyImages = lazyImages.filter(function(image) {
							return image !== lazyImage;
						});

						// Remove 'lazy' class after everything else is successful
						lazyImage.classList.remove("lazy-hidden");

						// Destroy EventListeners when image is loaded
						if (lazyImages.length === 0) {
							document.removeEventListener("scroll", lazyLoad);
							window.removeEventListener("resize", lazyLoad);
							window.removeEventListener("orientationchange", lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
			}
		};

		// Set EventListeners to watch for images on Scroll, Resize, or Orientation change.
		document.addEventListener("scroll", lazyLoad);
		window.addEventListener("resize", lazyLoad);
		window.addEventListener("orientationchange", lazyLoad);

		// Destroy EventListeners when no images are left to load
		if (lazyImages.length === 0) {
			document.removeEventListener("scroll", lazyLoad);
			window.removeEventListener("resize", lazyLoad);
			window.removeEventListener("orientationchange", lazyLoad);
		}

		// Trigger resize on load to load images currently in viewport
		window.dispatchEvent(new Event('resize'));
	},
};

export default LazyLoad;